import { useState } from "react";
import { InstrumentoFinanceiroApiResponse } from 'common/genericTypes';
import { getInstrumentoFinanceiroShortDescription } from 'common/genericDescriptions';
import { AutoComplete } from 'm2m.components';
import React, { useCallback, useMemo } from 'react';
import { Typography, Grid, Paper } from '@material-ui/core';
import moment from 'moment';
import _, { debounce } from 'lodash';

interface Props {
  instrumentos: Array<InstrumentoFinanceiroApiResponse>;
  instrumento: InstrumentoFinanceiroApiResponse | null;
  filteredOptions: InstrumentoFinanceiroApiResponse[];
  setSearchTerm: (value: string) => void;
  vertical?: boolean;
  label?: string | null;
  disabled?: boolean;
  onChange: (instrumento: InstrumentoFinanceiroApiResponse | null) => void;
}

const EventoExtraordinarioAutoComplete: React.FC<Props> = (props) => {
  const { instrumentos, instrumento, setSearchTerm, filteredOptions, vertical, label, disabled, onChange } = props;

  const debouncedSearch = useMemo(() => 
    debounce((value: string) => {
      setSearchTerm(value);
    }, 300), []);  

  // const filterInstrumentos = useCallback((options: Array<InstrumentoFinanceiroApiResponse>, value: string) => {
  //   var valueUpperCase = value.toUpperCase();
  //   return options.filter(
  //     (op) =>
  //       op?.codigo?.toUpperCase().includes(valueUpperCase) ||
  //       op?.razaoSocialEmissor?.toUpperCase().includes(valueUpperCase) ||
  //       op?.emissor?.razaoSocial?.toUpperCase().includes(valueUpperCase)
  //   );
  // }, []);
  
  // const sortedInstrumentos = useMemo(
  //   () => _.orderBy(instrumentos, (x) => moment(x.criteriosRemuneracao.dataEmissao), "desc"),
  //   [instrumentos]
  // );

  // const filteredOptions = useMemo(() => filterInstrumentos(instrumentos, searchTerm), [searchTerm, instrumentos, filterInstrumentos]);

  const width = vertical ? '400px' : '500px';
  const itemXs = vertical ? 4 : 6;

  return (
    <AutoComplete
      options={instrumentos}
      getOptionLabel={(option: InstrumentoFinanceiroApiResponse) => option.codigo}
      filterOptions={(options, state) => {
        debouncedSearch(state.inputValue);
        return filteredOptions;
      }}
      value={instrumento}
      onChange={onChange}
      disabled={disabled ?? false}
      filterSelectedOptions
      label={label ?? 'Instrumento para alocação *'}
      placeholder={'Pesquisar...'}
      PaperComponent={({ children }) => <Paper style={{ width, height: '100%' }}>{children}</Paper>}
      renderOption={(option: InstrumentoFinanceiroApiResponse) => (
        <div style={{ width: '100%' }}>
          <Grid container>
            <Grid item xs={itemXs}>
              <div>
                <Typography style={{ margin: 'auto' }} variant="subtitle2">
                  {'Data da Emissão'}
                </Typography>
              </div>
              <div>
                <Typography style={{ margin: 'auto' }}>
                  {moment(option.criteriosRemuneracao.dataEmissao).format('DD/MM/YYYY')}
                </Typography>
              </div>
            </Grid>
            <Grid item xs={itemXs}>
              <div>
                <Typography style={{ margin: 'auto' }} variant="subtitle2">
                  {'Número da Emissão'}
                </Typography>
              </div>
              <div>
                <Typography style={{ margin: 'auto' }}>{option.numeroEmissao}</Typography>
              </div>
            </Grid>
            <Grid item xs={itemXs}>
              <div>
                <Typography style={{ margin: 'auto' }} variant="subtitle2">
                  {'Emissor'}
                </Typography>
              </div>
              <div>
                <Typography style={{ margin: 'auto' }}>{option.razaoSocialEmissor}</Typography>
              </div>
            </Grid>
            <Grid item xs={itemXs}>
              <div>
                <Typography style={{ margin: 'auto' }} variant="subtitle2">
                  {'Valor da Emissão'}
                </Typography>
              </div>
              <div>
                <Typography style={{ margin: 'auto' }}>
                  {option.criteriosRemuneracao.volumeEmissao.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </Typography>
              </div>
            </Grid>
            <Grid item xs={itemXs}>
              <div>
                <Typography style={{ margin: 'auto' }} variant="subtitle2">
                  {'Instrumento'}
                </Typography>
              </div>
              <div>
                <Typography style={{ margin: 'auto' }}>
                  {getInstrumentoFinanceiroShortDescription[option.tipoInstrumentoFinanceiro]}
                </Typography>
              </div>
            </Grid>
            <Grid item xs={itemXs}>
              <div>
                <Typography style={{ margin: 'auto' }} variant="subtitle2">
                  {'Código do Ativo'}
                </Typography>
              </div>
              <div>
                <Typography style={{ margin: 'auto' }}>{option.codigo}</Typography>
              </div>
            </Grid>
          </Grid>
        </div>
      )}
      helperText={instrumento ? `${instrumento.numeroEmissao} - ${instrumento.razaoSocialEmissor}` : undefined}
    />
  );
};

export default EventoExtraordinarioAutoComplete;
